import { getCompanyInfo } from "@/model/CompanyInfo";
import { SINGLE_STEP_TPLID } from "@/utils/experiment";

export const isEnableCouponSize = (templateId?: string | number | null): boolean => {
  // 优惠券折扣值灰度不开放单步骤模板，避免影响线上单步骤弹窗配置
  if (SINGLE_STEP_TPLID.includes(String(templateId || ''))) {
    return false;
  }
  // 优惠券折扣值灰度公司白名单
  return true;
};
